import { useEffect, useState } from "react";
import { ConfigProvider } from "antd";
import { ToastContainer } from "react-toastify";

import Routes from "../routes";
import Navbar from "../components/Navbar";
import useStore from "../store/useStore";

const AppLayout = () => {
  const { isLoggedIn } = useStore();

  console.log("isLoggedIn ==>> ", isLoggedIn);

  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      <ToastContainer position="top-center" />

      {isLoggedIn ? (
        // <div>Loading</div>
        <>
          <ConfigProvider
            theme={{
              token: {
                /* here is your global tokens */
                fontFamily: "'Poppins', sans-serif",
                colorPrimary: "#26577C",
              },
            }}
          >
            <div
              className={`fixed h-screen bg-slate-50 transition-width border-2 border-solid border-slate-200 ${
                collapsed ? "w-20" : "w-64"
              }`}
            >
              <Navbar collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
            </div>

            <div className={`${collapsed ? "ml-20" : "ml-64"} flex-grow p-8`}>
              <Routes />
            </div>
          </ConfigProvider>
        </>
      ) : (
        <Routes />
      )}
    </>
  );
};

export default AppLayout;
